import { Component } from '@angular/core';

@Component({
  selector: 'app-material-timeline',
  templateUrl: './material-timeline.component.html',
  styleUrls: ['./material-timeline.component.less']
})
export class MaterialTimelineComponent {}
